import {useTranslation} from "@i18n/client";
import React from "react";
import {I18nNamespace} from "@i18n";

/**
 * Adds an empty space with padding around its children
 */
const EmptySlotGroup = ({children}: React.PropsWithChildren<unknown>) => (
  <div className="flex justify-center items-center min-h-[100px]">{children}</div>
);

/**
 * Renders a placeholder with a message to replace an empty group of slots.
 */
const NoSlots = () => {
  const {t} = useTranslation(I18nNamespace.WEB_SCHEDULING);
  return <EmptySlotGroup>{t("No Slots Available.", {ns: "web-scheduling"})}</EmptySlotGroup>;
};

export default React.memo(NoSlots);
